<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="title"><strong>Jack Whyte</strong></p>
<p class="title1"><strong>The Guardian</strong></p>
<p class="title2"><strong>A TALE OF SCOTTISH INDEPENDENCE</strong></p>
<p class="title3"><img alt="" src="OEBPS/images/logo.jpg"/><br/><strong>A TOM DOHERTY ASSOCIATES BOOK<br/> NEW YORK</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?3ddabf08